import { useParams } from 'react-router-dom';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { MultipleSelect, SelectOption } from '~/components';

const ModalityField = () => {
  const datasetId = +useParams().id!;
  const { data: modalityOptions, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.MODALITY });

  const selectOptions: SelectOption[] =
    modalityOptions?.map(({ value }) => ({
      value,
      label: value.replace(/_/g, ' '),
    })) || [];

  return (
    <MultipleSelect
      name="modality"
      label="MODALITY"
      options={selectOptions}
      placeholder="Select the modality"
      disabled={isFetching || !!datasetId}
    />
  );
};

export default ModalityField;
